
export default {
	props: ['error'],
	computed: {
		errorImg() {
			return Number(this.error.statusCode) === 404 ? 'https://oss.pzds.com/images/n404.png' : 'https://oss.pzds.com/imgv2/error-page-icon.png'
		}
	},
	head() {
		return {
			title: this.error.statusCode,
			meta: [
				{ name: 'robots', content: 'noindex, nofollow' } // 禁止爬虫抓取
			]
		}
	}
}
